import { useEffect, useRef, useState } from 'react';
import FilesServiceEdit from './FilesServiceEdit';
import { columnsheadId } from '../universal/columnshead';
import fetchApi from '../../utils/api/fetchApi';
import { Select, Space } from 'antd';
import getList from '../../utilsTsx/universal/getList';
import WebUniversal, { WUExtendPropsType } from '../system/WebUniversalNewEx';

const WebComponent = (props: any) => {

    const ref = useRef<any>(undefined);
    const apiId = 'filesService';

    /** 后端数据defaultService */
    const [defaultService, setDefaultService] = useState<string>('');
    const [InitData, setInitData] = useState<any>();
    const [filesServerData, setFilesServerData] = useState<any>();
    const [selectedServerId, setSelectedServerId] = useState<string | undefined>(undefined);

    useEffect(() => {
        let urlService;
        if (ref.current) {
            urlService = ref.current.defaultService;
            setDefaultService(urlService);
            setInitData(() => ref.current.initData);
        }
        fetchApi.GET(urlService,
            {
                apiId: 'filesServer',
                apiExtend: 'showList'
            }).then(res => {
                if (res.success) {
                    setFilesServerData(res.data);
                    for (const item of res.data) {
                        const { id, isDefault } = item;
                        if (isDefault === true) {
                            setSelectedServerId(id);
                            break;
                        }
                    }
                }
            })
    }, []);

    /**
     * 表头内容
     */
    const columnsHead = [
        {
            title: '服务名称',
            dataIndex: 'serviceName',
        }
    ];

    /**
     * 表头
     */
    const columns = columnsheadId
        .concat(columnsHead as []);

    /** 扩展Props */
    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '服务号',
        apiId,
        columns,
        showStates: true,
        EditComponent: FilesServiceEdit,
    };

    return (
        <>
            <Space>
                <Select
                    showSearch
                    placeholder="服务器"
                    optionFilterProp="children"
                    value={selectedServerId}
                    onChange={(e) => {
                        setSelectedServerId(e);
                        InitData({
                            apiId,
                            sendPageData: { filesServerId: e }
                        });
                    }}
                    style={{ width: 130 }}
                    filterOption={(input, option: any) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                    {getList.general(filesServerData, {
                        itemName: 'serverName'
                    })}
                </Select>
            </Space>
            <> </>
            <WebUniversal props={extendProps} ref={ref} />
        </>
    )
}

export default WebComponent;